import { Route, Routes } from 'react-router-dom';

import HomePage from './pages/HomePage.jsx';
import SharePage from './pages/SharePage.jsx';

/**
 * 路由表。
 *
 * 注意：下面的路径是**相对 site.basePath 的**。
 * 当前站点独占子域名根路径，basePath 为空，所以浏览器地址就是 /posts/1。
 * 如果以后改挂到子目录，实际地址才会多一层前缀（见 main.jsx 的 basename）。
 *
 *   /                下载引导页（直接访问域名子路径时落在这里）
 *   /s/:token        分享落地页（token 形态，能带卡片标题/描述）
 *   *                其余一律当「分享链接」处理
 *
 * 为什么最后一条是 SharePage 而不是「回首页」：
 * 分享链接的主形态直接就是 App 路由 —— https://host/posts/1，
 * 装了 App 的用户由系统（AASA / App Links）直接唤起，根本不会加载本页；
 * 没装 App 的才会走到这里，必须先尝试唤起、失败再引导下载。
 * 交给 SharePage 去判断「这个路径是不是合法的 App 路由」，
 * 不合法的再由它送去首页，避免用户停在空白页。
 */
export default function App() {
  return (
    <Routes>
      <Route path="/" element={<HomePage />} />
      <Route path="/s/:token" element={<SharePage />} />
      <Route path="*" element={<SharePage />} />
    </Routes>
  );
}
